export const GET_PAYMENT_PLAN_TEMPLATES_QUERY = `
  query GetPaymentPlanTemplates($where: payment_plan_templates_bool_exp) {
    payment_plan_templates(where: $where, order_by: { created_at: desc }) {
      id
      template_name
      description
      year
      payment_schedule
      company_id
      status
      created_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_PAYMENT_PLAN_TEMPLATE_BY_ID_QUERY = `
  query GetPaymentPlanTemplateById($id: Int!) {
    payment_plan_templates_by_pk(id: $id) {
      id
      template_name
      description
      year
      payment_schedule
      company_id
      status
      created_at
      company {
        id
        name
      }
    }
  }
`;
